import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { SAVE_HEALTH_PLAN_SELECTION_FROM_TRIAGE } from './triageHealthPlanActions'
import { NOT_ENROLLED_IN_HEALTH_INSURANCE_THROUGH_CUSTOMER } from '../../../../common/constants/healthPlanConstants'

const initialState = fromJS({
  selectedHealthPlan: {
    planName: NOT_ENROLLED_IN_HEALTH_INSURANCE_THROUGH_CUSTOMER.eligibility_name,
    bhbEligible: NOT_ENROLLED_IN_HEALTH_INSURANCE_THROUGH_CUSTOMER.enabled,
  },
})

export default createReducer(initialState, {
  [SAVE_HEALTH_PLAN_SELECTION_FROM_TRIAGE]: (state: $TSFixMe, action: $TSFixMe) => {
    return state.set('selectedHealthPlan', fromJS(action.selectedHealthPlan))
  },
})
